import { getSkillsTutorCourseKeyMap } from '../data'

interface GetSkillsTutorCourseKeyParams {
  productId: string
}

/**
 * Returns the courseKey for a given Skills Tutor productId
 * based on the current environment mapping.
 *
 * @param productId - The product ID
 * @returns courseKey string or empty string if not found
 */
export const getSkillsTutorCourseKey = ({ productId }: GetSkillsTutorCourseKeyParams): string => {
  const courseKeyMap = getSkillsTutorCourseKeyMap()

  return courseKeyMap[productId] || ''
}

export default getSkillsTutorCourseKey
